import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=8cdf6274&scoped=true&"
import script from "./RequestForm.vue?vue&type=script&lang=js&"
export * from "./RequestForm.vue?vue&type=script&lang=js&"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=8cdf6274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf6274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cdf6274')) {
      api.createRecord('8cdf6274', component.options)
    } else {
      api.reload('8cdf6274', component.options)
    }
    module.hot.accept("./RequestForm.vue?vue&type=template&id=8cdf6274&scoped=true&", function () {
      api.rerender('8cdf6274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lgpd/RequestForm.vue"
export default component.exports